export const enrichError = (error: Error, name: string): Error => {
  error.name = `${name} (${error.name})`;
  return error;
};
